import FormationsList from './FormationsList';

export default FormationsList;
